// Mlay motion layer: reveal sections and cards as they scroll into view
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && Shopify.designMode) return; // keep the theme editor static

  var root = document.documentElement;
  root.classList.add('mlay-motion');

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function mark(el, delay, type) {
    if (!el || el.classList.contains('mlay-reveal')) return;
    el.classList.add('mlay-reveal');
    el.setAttribute('data-anim', type || 'up');
    if (delay) el.style.setProperty('--mlay-delay', delay + 's');
    observer.observe(el);
  }

  function each(selector, type, stagger, max) {
    var counts = new Map();
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.closest('.mlay-reveal')) return; // don't nest reveals
      if (el.closest('.swiper, .swiper-wrapper, .swiper-slide') && !el.matches('.swiper')) return; // slider items move horizontally; animate the slider instead
      var parent = el.parentElement;
      var n = counts.get(parent) || 0;
      counts.set(parent, n + 1);
      mark(el, stagger ? Math.min(n, max || 8) * stagger : 0, type);
    });
  }

  function init() {
    var main = 'main .shopify-section:not(:first-child) ';
    // Headings rise in
    each(main + '.section-heading, ' + main + '.section-heading-wrapper, ' + main + '.mlay-features__head, ' + main + '.faq__list--wrapper--heading, ' + main + '.slider__heading--wrapper', 'up');
    // Split sections: text slides in from the reading side, media zooms in
    each(main + '.video-section__content, ' + main + '.mlay-compare__intro', 'start');
    each(main + '.video-section__media, ' + main + '.faq__media, ' + main + '.mlay-compare__table, ' + main + '.slideshow__media, ' + main + '.image--comparison-wrapper', 'zoom');
    // Cards and list items appear one after another
    each(main + '.product-grid-item, ' + main + '.banner_list_item, ' + main + '.mlay-features__item, ' + main + '.testimonail__grid--item, ' + main + '.faq__list--item, ' + main + '.mlay-compare__row', 'up', 0.08, 8);
    // Sliders (testimonials, product carousels) reveal as one block
    each(main + '.swiper', 'up');
    // Footer columns
    each('.footer .footer__widget, .footer [class*="footer__widget"]', 'up', 0.08, 6);

    // Scroll progress line
    var bar = document.createElement('div');
    bar.className = 'mlay-progress';
    document.body.appendChild(bar);
    var hero = document.querySelector('main .shopify-section:first-child .slideshow__media img');
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.transform = 'scaleX(' + (max > 0 ? window.scrollY / max : 0) + ')';
        // Gentle parallax on the hero image while it's on screen
        if (hero && window.scrollY < 900) hero.style.transform = 'translate3d(0,' + Math.min(window.scrollY * 0.06, 50) + 'px,0) scale(1.08)';
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// Inertia smooth scroll (Lenis) — desktop pointers only, off for reduced motion and in the theme editor
(function () {
  if (!window.Lenis) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.Shopify && Shopify.designMode) return;

  var lenis = new Lenis({ lerp: 0.1, smoothWheel: true, anchors: true });
  window.mlayLenis = lenis;
  function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
  requestAnimationFrame(raf);

  // Let scrollable panels scroll natively
  var panels = '.offcanvas-header, #predictive__search_overlay, .predictive-search, cart-drawer, .cart-drawer, .drawer, .mobile-facets, .facets__display, .modal, .quick-view, .popup, [role="dialog"]';
  function markPanels() {
    document.querySelectorAll(panels).forEach(function (el) { el.setAttribute('data-lenis-prevent', ''); });
  }
  markPanels();
  setTimeout(markPanels, 1500);

  // Pause while any drawer / modal locks the page
  var lockClasses = ['body-overflow-hidden', 'overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'offcanvas_open', 'modal-open'];
  function syncLock() {
    var locked = lockClasses.some(function (c) {
      return document.body.classList.contains(c) || document.documentElement.classList.contains(c);
    });
    if (locked) lenis.stop(); else lenis.start();
  }
  new MutationObserver(syncLock).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
  new MutationObserver(syncLock).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  // Back to top glides with Lenis
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#scroll__top');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    lenis.scrollTo(0, { duration: 1.2 });
  }, true);
})();
